import authority from './../authorityManage/authority.vue';
import dataAuthority from './dataAuthority.vue';
export default {
  components: {
    authority,
    dataAuthority
  },
  data() {
    return {
      activeKey: 1
    };
  }
};